import keccak256 from "keccak256";
import { useState } from "react";
import Admin from "./Admin";
import { Buffer } from "buffer/";
import { useEffect } from "react";
window.Buffer = window.Buffer || Buffer;

const Headmaster = () => {
  const [passed, setPassed] = useState(false);
  const [secretWord1, setSecretWord1] = useState("");
  const [secretWord2, setSecretWord2] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const pas = window.localStorage.getItem("headmaster");
    if (pas === "connected") {
      setPassed(true);
    }
  }, []);

  const enter = () => {
    const pass = keccak256(`${secretWord1}${secretWord2}`).toString("hex");
    if (pass === process.env.REACT_APP_HEADMASTER) {
      setError(null);
      window.localStorage.setItem("headmaster", "connected");
      setPassed(true);
    } else {
      setError("Wrong Combination!");
    }
    setSecretWord1("");
    setSecretWord2("");
  };

  const logout = () => {
    window.localStorage.removeItem("headmaster");
    setPassed(false);
  };

  return (
    <div className=" p-10 flex flex-col  text-white h-screen w-ful overflow-auto bg-gradient-to-bl from-purple-900 via-slate-900 to-black">
      <div className="flex justify-between items-center px-0 w-full">
        <h1 className="text-4xl m-4">Admin Page</h1>
        {passed && (
          <button
            onClick={() => logout()}
            className="text-white w-1/2 bg-blue-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
          >
            Logout
          </button>
        )}
      </div>
      {passed ? (
        <Admin />
      ) : (
        <div className=" font-bold m-auto items-center justify-center gap-4">
          <div className="mb-2">
            <label
              htmlFor="first_name"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-200"
            >
              First Secret Word
            </label>
            <input
              type="text"
              id="first_name"
              onChange={(e) => setSecretWord1(e.target.value)}
              value={secretWord1}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="last_name"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-200"
            >
              Second Secret Word
            </label>
            <input
              type="text"
              value={secretWord2}
              onChange={(e) => setSecretWord2(e.target.value)}
              id="last_name"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <button
            onClick={() => enter()}
            className="text-white w-1/2 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Submit
          </button>
          {error && (
            <p className="text-red-600 text-center text-lg my-2">{error}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Headmaster;
